module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-relative"
  }, [_c('div', {
    staticClass: "navigation"
  }, [_c('div', {
    staticClass: "position-back"
  }, [_c('div', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        return _vm.$emit('prev')
      }
    }
  }, [_vm._m(0), _c('span', [_vm._v("Previous step")])])])]), _vm._m(1), _c('div', {
    staticClass: "features address-info"
  }, [_c('div', {
    staticClass: "field field-address has-addons"
  }, [_c('div', {
    staticClass: "control is-medium is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "input is-medium",
    attrs: {
      "id": "address_input",
      "type": "text",
      "placeholder": 'Your ' + _vm.coin.symbol + ' address'
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.select.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control",
    attrs: {
      "id": "find_address"
    }
  }, [_c('a', {
    staticClass: "button is-medium",
    class: {
      'is-success': !_vm.hasErrors
    },
    attrs: {
      "disabled": _vm.hasErrors
    },
    on: {
      "click": _vm.select
    }
  }, [_c('span', [_vm._v("Next")])])])]), (_vm.errorAddressMessage) ? _c('p', {
    staticClass: "help help-small notif-danger"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.errorAddressMessage)
    }
  })]) : _vm._e(), (_vm.compatibleNetworks.length > 0 && (_vm.coin.chains.length > 1 || _vm.coin.chains[0].network !== _vm.coin.symbol)) ? _c('p', {
    staticClass: "help help-small notif-info"
  }, [_c('span', [_vm._v("Your address is compatible with the ")]), _vm._l((_vm.compatibleNetworks), function(o, index) {
    return _c('b', [_c('span', [_vm._v(_vm._s(o))]), (index < _vm.compatibleNetworks.length - 2) ? _c('span', [_vm._v(", ")]) : _vm._e(), (index === _vm.compatibleNetworks.length - 2) ? _c('span', [_vm._v(" and ")]) : _vm._e()])
  }), _c('span', [_vm._v(" network(s). ")]), (_vm.compatibleNetworks.length > 1) ? _c('span', [_vm._v("You may later switch payment networks.")]) : _vm._e()], 2) : _vm._e(), (_vm.coin && _vm.coin.symbol === 'XRP') ? _c('p', {
    staticClass: "help help-small notification is-warning is-light"
  }, [_c('span', [_vm._v("If you’ve just generated your XRP address in your wallet, ensure it is activated by transferring at least 1 XRP to it before your first mining payout.")])]) : _vm._e(), (_vm.coin && _vm.coin.regex_memo) ? _c('p', {
    staticClass: "help help-small notification is-warning is-light"
  }, [_c('span', [_vm._v("If you are mining to an exchange")]), _c('span', [_vm._v(" you must set your Memo or Payment Tag after your address, like this: ")]), _c('strong', {
    staticClass: "bg-warning text-white-on-dark"
  }, [_vm._v("YOUR_ADDRESS:YOUR_PAYMENT_TAG")])]) : _vm._e()]), _c('div', {
    staticClass: "feature-helvetica step-explanation"
  }, [_c('span', [_vm._v("This is where we will transfer your mining balance, you will also be able to track your progress by searching this address on the Address page.")]), _c('br'), _c('br'), _c('span', [_vm._v("If you do not have an address you can create one on a non-custodial wallet provider (recommended) or an exchange, here are some useful articles from our ")]), _c('router-link', {
    staticClass: "info-link mr-5",
    attrs: {
      "to": "/support",
      "target": "_blank"
    }
  }, [_vm._v("Support Center:")]), _c('div', {
    staticClass: "articles"
  }, [_c('router-link', {
    staticClass: "article-mini",
    attrs: {
      "to": "/support/article/how-to-create-a-metamask-wallet",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "article-inner"
  }, [_c('div', {
    staticClass: "article-title"
  }, [_c('span', [_vm._v(" How to create a metamask wallet")])]), _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])])]), _c('router-link', {
    staticClass: "article-mini",
    attrs: {
      "to": "/support/article/how-to-create-a-trust-wallet-account",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "article-inner"
  }, [_c('div', {
    staticClass: "article-title"
  }, [_c('span', [_vm._v(" How to create a Trust Wallet account")])]), _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])])])], 1), _c('span', [_vm._v("Some tokens or coins are supported on multiple networks, which you can switch at any time before a payout:")]), _c('div', {
    staticClass: "articles"
  }, [_c('router-link', {
    staticClass: "article-mini",
    attrs: {
      "to": "/support/article/what-is-multi-chain-support-and-how-to-use-it",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "article-inner"
  }, [_c('div', {
    staticClass: "article-title"
  }, [_c('span', [_vm._v(" What is multi chain support and how to use it?")])]), _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-title"
  }, [_c('span', [_vm._v("Your wallet address")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dd52ca4","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/get_started/c_step_address.vue
// module id = 373
// module chunks = 1